import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { filtersStore, isFiltered } from '~/modules/stores/searchFiltersStore';
import { GtmEventType, GtmFilterSearchEvent } from './gtmEventType';

export class GtmFilterSearchType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_FILTER_SEARCH &&
            event.elementType === 'filterInput' &&
            isFiltered(filtersStore.getState())
        );
    }
    // @ts-expect-error * Automated Type Error Fix
    getBody(event): GtmFilterSearchEvent {
        return {
            event: 'custEv_siteSearch',
            search_term: event.value,
            search_type: 'filter',
            search_result_count: event.searchContext.searchResultCount,
        };
    }
}
